import axios from "axios"
import { toast } from "react-toastify"

const fetchNewCommentRequest = () => {
	return {type: "FETCH_NEW_COMMENT_REQUEST"}
}

const fetchNewCommentSuccess = (new_comment) => {
	return {type: "FETCH_NEW_COMMENT_SUCCESS", payload: new_comment}
}

const fetchNewCommentFailure = (error) => {
	return {type: "FETCH_NEW_COMMENT_FAILURE", payload: error}
}

export const fetchNewComment = (data) => {
	return (dispatch) => {
		dispatch(fetchNewCommentRequest())
		axios.post("p/review", data)
		.then(response => {
			const new_comment = response.data
			dispatch(fetchNewCommentSuccess(new_comment))
			toast.dismiss()
			toast.success("پیام شما با موفقیت ارسال شد" , {position: 'bottom-right',className: 'foo-bar'})
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchNewCommentFailure(error))	
			if(err.response) {
				if(err.response.status === 422) {
					toast.dismiss()
					toast.error("لطفا تمام فیلدها را تکمیل کنید" , {position: 'bottom-right',className: 'foo-bar'})
				}
			}
		})
	}
}